import { format } from 'date-fns';

const DAY_MS = 864e5;

/** Whole days since `iso`. Negative when the stamp is in the future. */
export function ageDays(iso: string, now: Date = new Date()): number {
  return Math.floor((now.getTime() - new Date(iso).getTime()) / DAY_MS);
}

/** "today", "5 days ago", "3 weeks ago", "2 months ago", "1 yr ago". */
export function ageLabel(iso: string, now: Date = new Date()): string {
  const d = ageDays(iso, now);
  if (d <= 0) return 'today';
  if (d === 1) return 'yesterday';
  if (d < 14) return `${d} days ago`;
  if (d < 60) return `${Math.round(d / 7)} weeks ago`;
  if (d < 365) return `${Math.round(d / 30)} months ago`;
  return `${Math.round(d / 365)} yr ago`;
}

/** A moment shown as a calendar date in the viewer's own time zone. */
export function formatAbsoluteDate(iso: string): string {
  return format(new Date(iso), 'MMM d, yyyy');
}

/** A moment shown as a date and clock time in the viewer's own time zone. */
export function formatAbsoluteDateTime(iso: string): string {
  return format(new Date(iso), 'MMM d, h:mm a');
}
